import { createSlice } from '@reduxjs/toolkit'
import { sliceStateStatus } from '../../../../Core';

import ISliceState from '@/interface/core/ISliceState';
import IAssociation from '@/interface/IAssociation';

import {
  associationsIndex,
} from './associationsActions';



const initialState: ISliceState<IAssociation[]> = {
  data: [],
  status: sliceStateStatus.idle,
};

const associationsListSlice = createSlice({
  name: 'associationsList',
  initialState,
  reducers: {
    resetAssociationsListState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(associationsIndex.pending, (state) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(associationsIndex.fulfilled, (state, action) => {
        state.status = sliceStateStatus.fulfilled;
        state.data = action.payload.data; // Assumendo array
      })
      .addCase(associationsIndex.rejected, (state) => {
        state.status = sliceStateStatus.rejected;
      });
  }
});

export const { resetAssociationsListState } = associationsListSlice.actions;
export default associationsListSlice.reducer;

